<template>
    <div class="px-5 pb-5 my-5">
      <!-- <div class="row"> -->
        <VueSlickCarousel v-bind="settings" v-if="list">
          <div v-for="item in list" :key="item.id" class="">
            <div class="px-2">
              <router-link :to="{ name:'Article', params:{slug:item.slug} }">
              <!-- <img src="assets/images/Walt-Trust.jpg" alt=""> -->
              <img :src="ImageUrl+item.image" alt="" class="article-img">
              </router-link>
            </div>
          </div>
        </VueSlickCarousel>
      <!-- </div> -->
    </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'LastArticles',
  components:{
    VueSlickCarousel,
  },
  data(){
    return{
      settings:{
        "dots": true,
        "infinite": true,
        "initialSlide": 2,
        "speed": 500,
        "slidesToShow": 3,
        "slidesToScroll": 1,
        "swipeToSlide": true,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": true
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2,
              "initialSlide": 2
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      },
      list:null
    }
  },
  methods:{
    async getList(){
      await this.$axios.get(`lastArticles`)
      .then(res => {
          this.list = res.data.data
      })
      .catch(err => {
      });
    }
  },
  mounted(){
    this.getList()
  }
}
</script>
<style>
.slick-prev::before, .slick-next::before {
    color: var(--theme2) !important;
}
.article-img{
  border-radius: 15px;
  width: 100%;
}
</style>